import React from 'react'

const CaretDown = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <path
      d='M13.918 8L10 11.855 6.082 8l-.582.572L10 13l4.5-4.428z'
      fill={primaryColor}
      fillRule='evenodd'
      stroke={primaryColor}
      strokeWidth='0.5'
    />
  </svg>
)

export default CaretDown
